import { Content } from '../../types';

export const bayonTempleContent: Content = {
  title: 'מקדש באיון Bayon Temple – מקדש הפנים המחייכות של קמבודיה',
  imageUrl: 'https://tinyurl.com/bayon-preview',
  introduction: `מקדש באיון Bayon Temple הוא אחד המבנים המרהיבים והייחודיים ביותר במתחם אנגקור שבקמבודיה. הוא ממוקם בליבה של העיר העתיקה אנגקור תום ונבנה בסוף המאה ה-12 ותחילת המאה ה-13 על ידי המלך ג'יאווארמן השביעי, אשר הקדיש אותו לפולחן הבודהיסטי. המקדש מפורסם בזכות עשרות מגדליו המעוטרים בפסלי פנים ענקיים ומסתוריים, המעניקים לו מראה ייחודי ומיסטי.`,
  sections: [
    {
      title: 'ארכיטקטורה ועיצוב',
      content: `המקדש בנוי בסגנון הבודהיזם המהאיאני ומייצג את תפיסת עולמו של המלך ג'יאווארמן השביעי. מבנהו המרכזי מוקף במבוך של מעברים, חצרות וחדרים המקושטים בתבליטים מורכבים. המרכיב המרשים ביותר בבאיון הוא 54 המגדלים המקושטים ביותר מ-200 פני אבן ענקיים, אשר מביטים לכיוונים שונים בחיוך מסתורי. הפנים הללו, המזוהים לעיתים עם דמותו של המלך עצמו או עם דמותו של הבודהה לוקאסאמבהארה, מסמלים חכמה, חמלה ועוצמה.`,
      type: 'text-image',
      imageUrl: 'https://tinyurl.com/bayon-article-1',
    },
    {
      title: 'תבליטים וגילופים',
      content: `מקדש באיון מציג סצנות מחיי היומיום של האימפריה הקמרית לצד תיאורים היסטוריים ומיתולוגיים. התבליטים שעל קירות המקדש כוללים סצנות קרב בין הקמרים לצ'אמפים, חיי היומיום של התושבים וכן דמויות של אלים ומיתולוגיות בודהיסטיות. עושר הפרטים והדיוק האמנותי של התבליטים מעניקים הצצה נדירה אל התרבות וההיסטוריה של האימפריה הקמרית.`,
      type: 'text',
    },
    {
      title: 'השפעות דתיות ושינויי תקופה',
      content: `בעוד שמקדש באיון נבנה במקור כמקדש בודהיסטי, לאחר מותו של המלך ג'יאווארמן השביעי הוא עבר שינויים דתיים בהתאם לשליטים הבאים. בתקופות מסוימות נוספו לו אלמנטים הינדואיים ולאורך השנים חלו בו התאמות ושיפוצים שהשפיעו על עיצובו המקורי.`,
      type: 'text',
    },
    {
      title: 'ביקור במקדש',
      content: `המבקרים בבאיון חווים תחושה קסומה כאשר הם משוטטים בין המעברים הצרים, מול הפנים המחייכות שמביטות עליהם מכל עבר. הזמן האידיאלי לבקר במקום הוא בשעות הבוקר או אחר הצהריים, כאשר האור משחק עם הצללים ומדגיש את הבעת הפנים של הפסלים.`,
      type: 'text',
    },
    {
      title: 'סמל תרבותי והיסטורי',
      content: `מקדש באיון הוא לא רק מבנה ארכיטקטוני יוצא דופן אלא גם סמל לרוח התקופה של מלכי אנגקור. הוא מציג שילוב ייחודי של אמנות, דת והיסטוריה, מה שהופך אותו לאחד האתרים החשובים ביותר במתחם אנגקור.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, מקדש באיון הינו יצירת מופת של האדריכלות הקמרית ומהווה עדות מרשימה לתור הזהב של האימפריה הקמרית. החיוך המסתורי של פסלי האבן מעניק למקדש אווירה מיוחדת, ההופכת אותו לאחד היעדים הבלתי נשכחים בביקור בקמבודיה.`,
      type: 'text',
    },
  ],
};
